import { Reducer } from 'redux';
import { initialLanguageState, LanguageState } from './state';
import { RootAction } from '../../rootState';
import { languageActions } from './actions';
import { getType } from 'typesafe-actions';

export const reducer: Reducer<LanguageState, RootAction> = (state = initialLanguageState, action) => {
  switch (action.type) {
    case getType(languageActions.setLanguage): {
      return {
        ...state,
        language: action.payload.language,
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/language/reducer.tsx